import { GraduationCap, Clock, Monitor, CalendarDays, BookOpen, Award, Laptop, ArrowRight, Banknote, Users, Wifi, Star, Calendar, MapPin, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { CORSI } from "@/data/corsiData";

const CATEGORIE_FORMAZIONE = [
  { icon: Banknote,      slug: "formazione-finanziata",        titolo: "Formazione Finanziata per le Aziende del Terziario", desc: "Accedi a piani formativi finanziati tramite fondi interprofessionali" },
  { icon: Users,         slug: "apprendistato",                titolo: "Contratto di Apprendistato", desc: "Percorsi formativi integrati per l'inserimento dei giovani in azienda" },
  { icon: GraduationCap, slug: "aggiornamento-specializzazione", titolo: "Formazione Aggiornamento e Specializzazione", desc: "Crescita professionale continua per imprenditori e dipendenti" },
  { icon: Award,         slug: "formazione-abilitante",        titolo: "Formazione Abilitante e Progetti Speciali", desc: "SAB, ARC, AIM, Programma GOL, Accademia della Gastronomia e altri progetti speciali" },
  { icon: BookOpen,      slug: "formazione-obbligatoria",      titolo: "Formazione Obbligatoria", desc: "Sicurezza sul lavoro, HACCP, Privacy - corsi richiesti dalla normativa" },
  { icon: Wifi,          slug: "formazione-a-distanza",        titolo: "Formazione a Distanza (FAD)", desc: "Corsi online per la massima flessibilità di orari e luoghi" },
  { icon: Star,          slug: "formazione-personalizzata",    titolo: "Formazione Personalizzata Finanziata con il Fondo For.Te e FONDIR", desc: "Piani su misura per la tua azienda co-finanziati dai fondi paritetici" },
];


export default function FormazionePage() {
  return (
    <main id="main-content" data-testid="formazione-page">
      {/* Hero */}
      <section className="relative h-[320px] md:h-[380px] overflow-hidden" aria-labelledby="formazione-title">
        <img src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1920&q=60&auto=format" alt="Aula formazione" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.80)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Cresci con noi</span>
          <h1 id="formazione-title" className="text-4xl md:text-5xl font-bold text-white mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Formazione</h1>
          <p className="text-lg text-white/80 mt-4 max-w-3xl">
            Percorsi formativi per imprenditori, dipendenti e professionisti: HACCP, Sicurezza sul lavoro, digitalizzazione e molto altro.
          </p>
        </div>
      </section>

      {/* Testo introduttivo */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[var(--confcom-text-secondary)] leading-relaxed text-base">
            Confcommercio Roma, attraverso la sua società Promo.Ter srl, offre una vasta gamma di percorsi formativi per le imprese associate. L'offerta include corsi obbligatori in materia di Sicurezza sul lavoro, HACCP - Igiene degli alimenti e Privacy-GDPR. Sono inoltre disponibili corsi abilitanti per l'avvio di specifiche attività, come il corso SAB (ex-REC), per agenti immobiliari e agenti di commercio. Promo.Ter supporta le aziende nell'accesso a risorse per la formazione finanziata e al credito d'imposta per la formazione 4.0, offrendo anche soluzioni di formazione a distanza per rispondere alle esigenze di flessibilità delle imprese.
          </p>
        </div>
      </section>

      {/* Categorie formazione */}
      <section className="py-12 bg-[var(--confcom-bg-blue-light)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {CATEGORIE_FORMAZIONE.map((cat) => (
              <Link
                key={cat.slug}
                to={`/formazione/${cat.slug}`}
                style={{ textDecoration: "none" }}
              >
                <div className="bg-white rounded-xl p-5 border border-[var(--confcom-border)] h-full flex flex-col hover:shadow-md hover:-translate-y-0.5 transition-all">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4 bg-[var(--confcom-bg-blue-light)]">
                    <cat.icon size={20} className="text-[var(--confcom-blue)]" aria-hidden="true" />
                  </div>
                  <h3 className="text-sm font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-1">{cat.titolo}</h3>
                  <p className="text-xs text-[var(--confcom-text-secondary)] leading-relaxed mb-3 flex-1">{cat.desc}</p>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-[var(--confcom-blue)] mt-auto">
                    Scopri <ChevronRight size={12} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Calendario Corsi */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: "2.5rem", flexWrap: "wrap", gap: "1rem" }}>
            <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">
              Calendario Corsi
            </h2>
            <Link
              to="/formazione/corsi-in-partenza"
              className="inline-flex items-center gap-1 text-sm font-medium text-[var(--confcom-blue)] hover:gap-2 transition-all"
            >
              Vedi tutti <ChevronRight size={16} />
            </Link>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "1.5rem" }} data-testid="formazione-list">
            {CORSI.map((corso) => (
              <Link
                key={corso.slug}
                to={`/formazione/corsi-in-partenza/${corso.slug}`}
                data-testid={`corso-${corso.slug}`}
                style={{ textDecoration: "none" }}
              >
                <div
                  style={{
                    background: "#fff",
                    border: "1px solid var(--confcom-border)",
                    borderRadius: "1rem",
                    overflow: "hidden",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  className="hover:shadow-lg hover:-translate-y-0.5 transition-all"
                >
                  {/* Immagine */}
                  <div style={{ height: 180, overflow: "hidden", position: "relative" }}>
                    <img
                      src={corso.immagine}
                      alt={corso.titolo}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                    <div
                      style={{
                        position: "absolute", top: "0.75rem", left: "0.75rem",
                        background: corso.categoriaColor, color: "#fff",
                        fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase",
                        letterSpacing: "0.1em", padding: "0.3rem 0.7rem", borderRadius: "2rem",
                      }}
                    >
                      {corso.categoria}
                    </div>
                    <div
                      style={{
                        position: "absolute", top: "0.75rem", right: "0.75rem",
                        background: "rgba(255,255,255,0.92)", color: corso.categoriaColor,
                        fontSize: "0.72rem", fontWeight: 800, letterSpacing: "0.08em",
                        padding: "0.3rem 0.7rem", borderRadius: "2rem", fontFamily: "monospace",
                      }}
                    >
                      {corso.codice}
                    </div>
                  </div>

                  {/* Contenuto */}
                  <div style={{ padding: "1.25rem 1.5rem", flex: 1, display: "flex", flexDirection: "column" }}>
                    <h3
                      className="font-['Encode_Sans_Semi_Condensed']"
                      style={{ fontSize: "1rem", fontWeight: 700, color: "var(--confcom-text-primary)", marginBottom: "0.85rem", lineHeight: 1.3 }}
                    >
                      {corso.titolo}
                    </h3>

                    <div style={{ display: "flex", flexDirection: "column", gap: "0.45rem", marginBottom: "1rem" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.82rem", color: "var(--confcom-text-secondary)" }}>
                        <Calendar size={13} color="var(--confcom-blue)" />
                        <span>Inizio: <strong style={{ color: "var(--confcom-text-primary)" }}>{corso.dataInizio}</strong></span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.82rem", color: "var(--confcom-text-secondary)" }}>
                        <Clock size={13} color="var(--confcom-blue)" />
                        <span>{corso.durata}</span>
                      </div>
                    </div>

                    <div
                      style={{
                        background: "#F0F7FF", borderRadius: "0.5rem",
                        padding: "0.5rem 0.85rem", fontSize: "0.82rem",
                        color: "var(--confcom-blue)", fontWeight: 700, marginBottom: "1rem",
                      }}
                    >
                      {corso.quota}
                    </div>

                    <div style={{ marginTop: "auto" }}>
                      <span className="inline-flex items-center gap-1 text-sm font-medium text-[var(--confcom-blue)]">
                        Scopri il corso <ChevronRight size={16} />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Banner Promo.Ter */}
      <section className="overflow-hidden">
        <div className="max-w-7xl mx-auto border border-[var(--confcom-border)] rounded-2xl overflow-hidden my-8 mx-4 lg:mx-auto" style={{ backgroundColor: "#0b0f3c" }}>
          <div className="grid lg:grid-cols-2 items-stretch">
            <div className="px-8 lg:px-16 py-14" style={{ backgroundColor: "#0b0f3c" }}>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Erogati da</span>
              <h2 className="text-3xl md:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight mt-3 mb-5">
                Tutti i corsi sono erogati da Confcommercio Roma attraverso <span className="text-[#56B7E6]">Promo.Ter</span>
              </h2>
              <p className="text-white/70 leading-relaxed mb-6">
                Promo.Ter è la società di formazione e servizi di Confcommercio Roma, accreditata presso la Regione Lazio e certificata ISO 9001:2015. Garantisce standard formativi elevati, docenti qualificati e un'ampia offerta per le imprese del terziario.
              </p>
              <div className="text-sm text-white/60 mb-6 space-y-1">
                <p>Contatta l'Area Formazione:</p>
                <p>Tel. <a href="tel:+390668437462" className="text-white/80 hover:text-white transition-colors">06.68437462-454</a> | Email: <a href="mailto:promoter@confcommercioroma.it" className="text-white/80 hover:text-white transition-colors">promoter@confcommercioroma.it</a></p>
              </div>
              <Link
                to="/chi-siamo/enti-collegati/promo-ter"
                className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-7 py-3 rounded-md font-bold hover:opacity-90 transition-opacity shadow-lg"
                data-testid="banner-promoter-cta"
              >
                Scopri Promo.Ter <ArrowRight size={18} aria-hidden="true" />
              </Link>
            </div>
            <div className="hidden lg:flex items-end justify-center" style={{ backgroundColor: "#0b0f3c" }}>
              <img src="/banner-promoter-new.png" alt="Promo.Ter - Formazione e servizi per il terziario" className="w-4/5 object-contain" />
            </div>
          </div>
        </div>
      </section>

      {/* CTA contatti */}
      <section className="py-16 mt-10 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/cta-background.jpg" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 59, 117, 0.88)" }} />
        </div>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <h3 className="text-2xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] mb-3">Hai bisogno di informazioni sulla formazione?</h3>
          <p className="text-white/80 mb-6">Contatta l'Area Formazione: Tel. 06.68437 606 - 530 | Email: promoter@confcommercioroma.it</p>
          <Link to="/contatti" className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-8 py-4 rounded-md font-semibold hover:opacity-90 transition-opacity shadow-lg" data-testid="formazione-contatti-cta">
            Contattaci <ArrowRight size={18} aria-hidden="true" />
          </Link>
        </div>
      </section>
    </main>
  );
}
